import { forwardRef } from "react";
import { MaskedInput, type MaskedInputProps } from "./MaskedInput";
import { formatCnpj } from "../../lib/format";

export type CnpjInputProps = Omit<MaskedInputProps, "mask">;

export const CnpjInput = forwardRef<HTMLInputElement, CnpjInputProps>(
  function CnpjInput(props, ref) {
    return (
      <MaskedInput
        ref={ref}
        inputMode="numeric"
        autoComplete="off"
        placeholder="00.000.000/0000-00"
        mask={formatCnpj}
        {...props}
      />
    );
  }
);
